import moment from "moment";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import { EVENTS, isObjectEmpty } from "@/utils";
import AccountsMixin from "./AccountsMixin.vue";
import InitializeFiltersMixin from "./InitializeFiltersMixin.vue";
import FetchFiltersMixin from "./FetchFiltersMixin.vue";
export default {
  name: "PricingAndMarginMixin",
  mixins: [AccountsMixin, InitializeFiltersMixin, FetchFiltersMixin],
  mounted() {},
  ...mapGetters(["pricingAndMarginSellersListGet"]),
  methods: {
    ...mapMutations(["pricingMarginSellersFilterSet", "pricingMarginMarketplacesFilterSet"]),
    ...mapActions(["pricingAndMarginGetByFilters"]),
    async getFilterValuesForSellersFilter() {
      //console.log("[initialize sellersfilter for pricing and margin]");
      this.sellers = await this.getOmnyAccountSellers();
      if (this.sellers.length === 0) {
        this.handleErrorOccured();
        return;
      }
      return this.sellers;
    },
    async getFilterValuesForMarketPlacesFilter() {
      const path = `/inventory/pricing_and_margin/filters/countries`;
      this.marketplaces = await this.getCountriesBasedOnSellers({
        sellers: this.currentSellerIds
      }, path);
      //console.log("[marketplaces from pricing and margin mixin]");
      //console.log(this.marketplaces);
      return this.marketplaces;
    }
  }
};